import devices from './devices'
import media from './media'
import tracks from './tracks'
import sessions from './sessions'
import browser from './browser'

/**
 * Webrtc plugin top-level reducer.
 * @method reducer
 * @param  {Object} [state={}]
 * @param  {Object} action
 * @return {Object}
 */
export default function (state = {}, action) {
  return {
    devices: devices(state.devices, action),
    tracks: tracks(state.tracks, action),
    sessions: sessions(state.sessions, action),
    media: media(state.media, action),
    browser: browser(state.browser, action)
  }
}
